import { AnyAction, IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { Wfs3dLayersState } from "../../wfs3dLayers.reducer";

export const wfs3dLayerCountPartialReducer: IPartialReducer<Wfs3dLayersState> = (
    state: Wfs3dLayersState,
    action: AnyAction
) => {
    const layerCount = state.layerCount ? { ...state.layerCount } : {};
    layerCount[action.layerGroup] = action.layerCount;

    return {
        layerCount: layerCount,
        loading: true,
    };
};
